// ** React Imports
import React from "react";

// ** Custom Components
import Icon from "./Icon";

// #####################################################

/**
 * Factory function do tworzenia wrapper komponentów dla konkretnych ikon
 *
 * @param {string} iconName - Nazwa ikony z rejestru
 * @param {string} defaultVariant - Domyślny wariant ikony
 * @returns {React.Component} - Komponent wrapper dla konkretnej ikony
 */
export const createIconComponent = (iconName, defaultVariant = "solid") => {
	const IconComponent = ({ variant = defaultVariant, ...props }) => {
		return <Icon name={iconName} variant={variant} {...props} />;
	};

	// Ustawienie nazwy komponentu dla lepszego debugowania
	IconComponent.displayName = `${iconName
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join("")}Icon`;

	return IconComponent;
};

// #####################################################

export default createIconComponent;
